import { memo } from "react"

const ErrorComponent: React.FC<{ type: 'Knowledge Base' | 'Tickets' | 'No Category' | 'Page not published' }> = ({ type }) => {

  const getTitle = () => {
    switch (type) {
      case "Knowledge Base":
        return 'Page not available';
      case "Tickets":
        return 'Help desk not available'
      case "Page not published":
        return 'Page not published';
      default:
        return 'No search results'
    }
  }

  const getDescription = () => {
    switch (type) {
      case "Knowledge Base":
        return 'We are currently experiencing some technical difficulties. Please try again later. #100001';
      case "Tickets":
        return 'We are currently experiencing some technical difficulties. Please try again later. #100002';
      case "Page not published":
        return 'We are updating the content of this page. Please try again later. #100003';
      default:
        return 'We couldn’t find any results matching your search. Please try rephrasing your search query'
    }
  }

  return <div id='ele-50' className="flex flex-col justify-center flex-grow items-center text-center">
    <div id='ele-51' className="mb-8">
      <img src={process.env.REACT_APP_CDN + "/error.svg"} alt="refresh" className="inline-block w-16" />
    </div>
    <div id='ele-52' className="font-mSemiBold mb-2">{getTitle()}</div>
    <div id='ele-53' className="text-lightText text-sm">{getDescription()}</div>
  </div>
}

export default memo(ErrorComponent);